window.bindQuickAddBtns = function(scope) {
  const container = scope || document;
  const quickAddBtns = container.querySelectorAll("[data-quick__add]");
  
  quickAddBtns.forEach((quickAddBtn) => {
    if (quickAddBtn.dataset.qaBound === "true") return;
    quickAddBtn.dataset.qaBound = "true";

    quickAddBtn.addEventListener("click", function(event){
      event.stopPropagation(); // Prevent bubbling issues
      this.classList.toggle("active");
      const variantWrapper = this.querySelector(".qa__variant-wrapper");
      if (variantWrapper) {
        variantWrapper.classList.toggle("active");
      }
    });

    // Find the closest grid-product__has-quick-shop parent
    const parentContainer = quickAddBtn.closest(".grid-product__has-quick-shop");

    if (parentContainer && parentContainer.dataset.qaBound !== "true") {
      parentContainer.dataset.qaBound = "true";
      parentContainer.addEventListener("mouseleave", function(){
        const activeVariantWrapper = parentContainer.querySelector(".qa__variant-wrapper");
        if (activeVariantWrapper) {
          activeVariantWrapper.classList.remove("active");
          const btns = parentContainer.querySelectorAll("[data-quick__add]");
          btns.forEach((btn) => {
            btn.classList.remove("active");
          });
        }
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", function(){
  window.bindQuickAddBtns();

  // Loyalty Popup Handlers
  window.openLoyaltyModal = function() {
    const modal = document.getElementById('loyalty-popup');
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeLoyaltyModal = function() {
    const modal = document.getElementById('loyalty-popup');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      window.closeLoyaltyModal();
    }
  });
});
